export default {
  "hero": {
    "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yorkshire Terrier"])}
  },
  "lost": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si me pierdo, por favor ayúdame"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puede que esté asustado. Por favor sé amable conmigo y contacta a mi familia usando el formulario — te responderán lo antes posible."])},
    "form": {
      "subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Encontraron a Manolito!"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu nombre"])},
      "name_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juan Pérez"])},
      "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu teléfono o correo"])},
      "contact_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+57 300 000 0000"])},
      "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Dónde me encontraste?"])},
      "location_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parque, calle, barrio..."])},
      "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Información adicional"])},
      "message_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está bien? Cualquier detalle que ayude..."])},
      "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar mensaje a mi familia 🐾"])}
    }
  },
  "petting": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dónde me gusta que me consientan"])},
    "spots": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detrás de las orejas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La espalda"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La barbilla"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La panza"])}
    ]
  },
  "loves": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lo que me encanta"])},
    "items": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parques con pasto"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Caminar en las montañas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salir a caminar"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ramitas del parque"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saludar a otros perritos"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Los perritos blancos especialmente"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perseguir pelotas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jugar a las perseguidas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jalar la cuerda"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destruir cajas de cartón"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desenrollar el papel higiénico"])}
    ]
  },
  "fears": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lo que me da miedo"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por favor mantenme lejos de esto — puede que intente correr o esconderme."])},
    "items": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Algunas bicicletas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ramas apiladas de forma sospechosa"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personas con cascos o uniformes grandes"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonidos de animales silvestres"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bolsas de basura apiladas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El mar"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Las alturas"])}
    ]
  },
  "chases": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lo que me hace salir corriendo"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Por favor agarra bien mi correa! Puedo escaparme sin avisar."])},
    "items": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otros perros"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perritos blancos"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pelotas de otros perros"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palomas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aves pequeñas"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pescados — ¡me tiro al agua!"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personas que se parecen a alguien que conozco"])}
    ]
  },
  "diet": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mi alimentación"])},
    "cant_eat_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No puedo comer"])},
    "forbidden": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🧅 Cebolla"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍫 Chocolate"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🥜 Nueces"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🪵 Palos del parque o madera"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍋 Frutos ácidos"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍬 Azúcar"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🧂 Sal"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍽️ Comida de humanos en general"])}
    ],
    "schedule_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Como tres veces al día"])},
    "schedule_desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Como un salchichón de comida húmeda que guardan en el congelador. Así se prepara:"])},
    "steps": [
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🌙 La noche anterior"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sacar el salchichón del congelador y dejarlo a temperatura ambiente toda la noche."])}
      },
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["☀️ 8:00 a.m."])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El salchichoncito debe estar blandito. Abrirlo y calentar 1/3 del contenido en el microondas en un plato de porcelana. Esperar dos minutos a que se enfríe antes de servir."])}
      },
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🌤️ 12:00 p.m."])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calentar otro 1/3 del salchichoncito en el microondas. Esperar dos minutos a que se enfríe antes de servir."])}
      },
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🌆 En la tarde/noche"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calentar el último 1/3 en el microondas. Esperar dos minutos a que se enfríe antes de servir."])}
      }
    ]
  },
  "commands": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lo que sé hacer"])},
    "items": [
      {
        "word": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sentado"])},
        "how": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Di \"sit\" y me siento."])}
      },
      {
        "word": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Girar"])},
        "how": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haz un puño, estira el dedo índice y dibuja un círculo hacia la derecha — ¡giro!"])}
      },
      {
        "word": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dar la mano"])},
        "how": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acerca tu mano a mi pata y di \"jalo\" (hallo) — ¡te doy la mano!"])}
      }
    ]
  },
  "vet": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si me enfermo"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clínica Veterinaria Loyal Animals"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contactar veterinaria por WhatsApp"])}
  },
  "footer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hecho con 🐾 y amor"])},
  "nav": {
    "cuidados": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuidados"])}
  },
  "home": {
    "tagline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yorkshire Terrier"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soy un perrito muy aventurero.\nSi me encontraste, escríbele a mi familia 🐾"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cómo cuidarme →"])}
  },
  "cuidados": {
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todo lo que necesitas saber para cuidarme bien."])}
  }
}